import styled from 'styled-components';

export const MessageBubble = styled.div`
  background-color: ${props => props.left && props.left === "true" ? '#84d4b0' : '#f0f0f0'};
  padding: 8px 12px;
  border-radius: 10px;
  margin: 4px;
  ${props => props.left && props.left === "true" && 'text-align: left;'}
`;

export const ChatContainer = styled.div`
  border: 1px solid #ccc;
  border-radius: 8px;
  width: 500px;
  padding: 16px;
`;

export const MessageList = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 500px;
  overflow: auto;
  margin-bottom: 10px;
`;